import Compressor from "compressorjs";

export function singleImageCompressor(file, fileResult) {
    if (!file) {
        return;
    }
    new Compressor(file, {
        quality: 0.75,
        maxHeight: 1200,
        maxWidth:1200,
        success(result) {
            const reader = new FileReader();
            reader.readAsDataURL(result);
            reader.onload = () => {
                fileResult.pop();
                fileResult.push({
                    id: 0,
                    base64: reader.result,
                    path: null
                });
            };
        },
        error(err) {
            console.log(err.message);
            return false;
        }
    });
}
export function multiImageCompressor(files, fileResult, fileType) {
    if (!files) {
        return;
    }
    for (const file of files) {
 
        new Compressor(file, {
            quality: 0.75,
            maxHeight: 1200,
            maxWidth: 1200,
            success(result) {
                const reader = new FileReader();
                reader.readAsDataURL(result);
                reader.onload = () => {
                    fileResult.push({
                        id: 0,
                        base64: reader.result,
                        description: "", 
                        path: null,
                        state: 1
                    });
                };
            },
            error(err) {
                console.log(err.message);
                return false;
            }
        });
 }
}
export function deleteImage(index, filesInput) {
    const state = filesInput[index].state;
    if(state == 1)
    {
        filesInput.splice(index, 1);
    }
    else if(state == 0) {
        filesInput[index].state = 2;
    }
}